import StorageHelper from '../../../helper';

const scope = 'CAMP/actions';

function getGetOrdinal(n) {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

const computeActionStatusString = (actions) => {
  let offset = 0;
  return actions.map((x, index) => {
    if (x.enabled) {
      x.caption = getGetOrdinal(index + 1 - offset).concat(' Action'); // eslint-disable-line
    } else {
      x.caption = 'Disabled'; // eslint-disable-line
      offset += 1;
    }
    return x;
  });
};

const mod = {
  namespaced: true,
  state: {
    actionList: [],
    advancedMessageAssignment: false
  },
  mutations: {
    actionList: (state, actionList) => {
      state.actionList = actionList; // eslint-disable-line
    },
    advancedMessageAssignment(state, value) {
      state.advancedMessageAssignment = value;
    }
  },
  actions: {
    actionList({ commit }, actionList) {
      StorageHelper.setLocalStorageVar(
        commit,
        computeActionStatusString(actionList),
        'actionList',
        scope // eslint-disable-line
      );
    },
    advancedMessageAssignment({ commit }, value) {
      const commitKey = "advancedMessageAssignment";

      StorageHelper.setLocalStorageVar(commit, value, commitKey, scope);

      if (window.CampaignDesignPage !== undefined) {
        window.CampaignDesignPage.smarttargeting = !!value;
      }
    }
  },
  getters: {
    actionList: state => state.actionList,
  },
};

export {
  mod as default,
  computeActionStatusString, // export this for testing purpose
};
